// @flow
/* -----------------Globals--------------- */
import { useCallback, useState } from "react";

/* -----------------Types--------------- */
import type { SuggestionType } from "../types/suggest-correction";

import type { Choice } from "@memorang/types";
import useCurrentSession from "./useCurrentSession";
import useSessionStore from "./useSessionStore";

const useSuggestCorrection = (_currentItemIndex?: number) => {
	const [loading, setLoading] = useState(false);
	const [source, setSource] = useState("");
	const [correction, setCorrection] = useState("");

	const itemStates = useSessionStore((state) => state.itemStates);
	const { currentItem } = useCurrentSession();
	const getQuizModeDetails = (
		choices: Choice[],
		question?: string,
		selectedChoiceIds?: string[],
	) => {
		const correctChoice = choices.find((item) => item.isCorrect);
		const getChoices = () =>
			choices.map((choice) => {
				const currentChoice = {
					name: choice.text,
					isCorrect: correctChoice?.id === choice.id,
					isChosen: selectedChoiceIds?.includes(choice.id),
				};
				return currentChoice;
			});

		const finalChoices = getChoices();
		const quiz = {
			question,
			choices: finalChoices,
		};
		return {
			mode: "QUIZ" as const,
			quiz,
		};
	};

	// biome-ignore lint/correctness/useExhaustiveDependencies: // TODO fix me later
	const callSuggestCorrection = useCallback(
		(_suggestion: SuggestionType) => {
			setLoading(true);

			const choices =
				currentItem?.response?.type === "choice"
					? currentItem?.response?.choices!
					: [];
			const id = currentItem?.id!;
			const stem = currentItem?.content?.stem;
			const selectedChoiceIds = itemStates?.get(id)?.selectedChoiceIds;
			const _modeDetails = getQuizModeDetails(
				choices,
				stem?.text,
				selectedChoiceIds,
			);
			// await suggestCorrection(id, suggestion, modeDetails);
			setLoading(false);
		},
		[currentItem, itemStates],
	);

	const getFlipModeDetails = (
		frontOfCardContent: string,
		backOfCardContent: string,
	) => {
		const flip = {
			frontOfCardContent,
			backOfCardContent,
		};
		return {
			mode: "FLIP",
			flip,
		};
	};

	return {
		loading,
		callSuggestCorrection,
		getQuizModeDetails,
		getFlipModeDetails,
		setCorrection,
		setSource,
		source,
		correction,
	};
};

export default useSuggestCorrection;
